import React from "react";
import "./ViewBar.css";
import { Link } from "react-router-dom";

export default function Viewbar(props) {
  const { isViewAsCollege, tabProfileActive, collegeID } = props;
  // let roleControlToggle;
  let viewBarInfo;
  let internalLink;
  let tolink;

  if (isViewAsCollege) {
    viewBarInfo = "You are viewing Profile as Personnel";
    // internalLink = <Link title="Ready Teacher" to={`/PreviewProfile2`} >View as College</Link>
    //Yuan: redux
    // tolink = tabProfileActive ? `/previewProfile` : `/previewResume`
    tolink = "/CollegePreviewProfile";
    internalLink = (
      <Link title="Ready Teacher" to={tolink}>
        View as Teacher
      </Link>
    );
  } else {
    viewBarInfo = "You are viewing Profile as Teacher";
    // internalLink = <Link title="Ready Teacher" to={`/home2`}>View as Teacher</Link>
    //Yuan: redux
    // tolink = tabProfileActive ? `/` : `/resume`
    tolink = "/Profile";
    internalLink = (
      <Link title="Ready Teacher" to={tolink}>
        View as Personnel
      </Link>
    );
  }

  return (
    <div className="review-control-bar">
      <div className="review-control-bar-virtual-div"></div>
      <div>{viewBarInfo}</div>
      <div className="role-control-toggle">{internalLink}</div>
    </div>
  );
}
